import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {TokenService} from "./services/token.service";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private tokenService: TokenService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return Observable.create((observer) => {
            let authenticated = this.tokenService.getToken() !== '';

            console.log('AuthGuard', authenticated);

            observer.next(authenticated);

            if (!authenticated) {
                this.router.navigate(['/login']);
            }

            // return observer;
        });
    }

}